"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailFormat = {
    Mail: 1,
    Email: 2
};
